import moment from "moment";
import { escapeHtml } from "../../utils/formatters";

function formatDate(movement) {
  return movement?.date
    ? escapeHtml(moment(movement.date).format("DD/MM/YYYY HH:mm"), "-")
    : "-";
}

export function buildBultoLocationTooltipHtml(items) {
  const list = Array.isArray(items) ? items : [items];
  if (!list.length) return "";

  const first = list[0];
  const addressLabel = escapeHtml(first?.movement?.address?.address, "-");
  const warehouseName = escapeHtml(first?.movement?.warehouse?.name);

  const bultosHtml = list
    .map((item) => {
      const barcodeLabel = escapeHtml(item?.barcode, "-");
      return `<div><strong>Bulto:</strong> ${barcodeLabel} — ${formatDate(item?.movement)}</div>`;
    })
    .join("");

  return `
    <div class="map-stop-popup">
      <div><strong>Direccion:</strong> ${addressLabel}</div>
      ${warehouseName ? `<div><strong>Almacen:</strong> ${warehouseName}</div>` : ""}
      ${bultosHtml}
    </div>
  `;
}
